import { type DefaultContext, mutationPromise } from '@egw/clients'
import { createMutationHook } from '../../../../hooks'
import {
  type EnrollmentMultiSignInSubmitInput,
  type EnrollmentMultiSignInSubmitOutput,
} from '../../../../models/enrollment/multi/return-sign-in'

/**
 * Submit Enrollment Multi SignIn data
 * @param context - reference to the AbortController used to abort the call (optional)
 * @returns Promise<EnrollmentMultiSignInSubmitOutput>
 * @example const response = await submitEnrollmentMultiSignInData();
 */
export const submitEnrollmentMultiSignInData = async (
  enrollmentSignInSubmitInput: EnrollmentMultiSignInSubmitInput,
  context?: DefaultContext,
): Promise<EnrollmentMultiSignInSubmitOutput> => {
  const response = (await mutationPromise(
    {
      name: 'submitEnrollmentMultiSignInData',
      query: `mutation submitEnrollmentMultiSignInData($input: ReentryInput!) {
        enterApplication(input: $input) {
          nextStep
          error
        }
      }`,
    },
    {
      input: enrollmentSignInSubmitInput,
    },
    context,
  )) as { enterApplication: EnrollmentMultiSignInSubmitOutput }
  return response.enterApplication
}

export const useSubmitEnrollmentMultiSignInData = createMutationHook<
  EnrollmentMultiSignInSubmitInput,
  EnrollmentMultiSignInSubmitOutput
>(submitEnrollmentMultiSignInData)
